import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  TopToolbar,
  CreateButton,
  ExportButton,
} from 'react-admin';

const ListActions = () => (
  <TopToolbar>
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

const ConfigsList = () => (
  <List resource="configs" actions={<ListActions />}>
    <Datagrid>
        <TextField source="Name"  label="Nome"/>
        <TextField source="CreatedDate" label="Dta. Criação"/>
        <TextField source="CreatedBy" label="Criada por"/>
        <TextField source="ModifiedDate" label="Dta. Edição"/>
        <TextField source="ModifiedBy" label="Editada por"/>
    </Datagrid>
  </List>
);

export default ConfigsList;
